import __base_store from '@/store/__base_store'

/**
 * Store de descuentos de orden de proveedor.
 */
export default __base_store({
	state: {
		model_name: 'provider_order_discount',
	},
})

